import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { PlusIcon } from '@heroicons/react/solid';
import Card from './Card';
import { Preview as InfographicPreview } from './components/infographic';
import { Preview as MultiplechoicePreview } from './components/Multiplechoice';
import { Preview as OpenQuestionPreview } from './components/Open';
import { Preview as SummaryPreview } from './components/Summary';
import { Preview as Mp4Preview } from './components/Mp4';

function Module(props) {
  const { item, selected } = props;
  switch (item.type) {
    case 'infographic':
      return <InfographicPreview item={item} selected={selected} />;
    case 'multiplechoice':
      return <MultiplechoicePreview selected={selected} />;
    case 'open': {
      return <OpenQuestionPreview selected={selected} />;
    }
    case 'summary': {
      return <SummaryPreview selected={selected} />;
    }
    case 'mp4': {
      return <Mp4Preview selected={selected} />;
    }
    default:
      throw new Error(`${item.type} is not a valid component type`);
  }
}

Module.propTypes = {
  item: PropTypes.objectOf({
    type: PropTypes.string,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
};

function PreviewList(props) {
  const {
    cards,
    moveCard,
    setSelectedCard,
    selectedCard,
    setUploadDialogOpen,
  } = props;

  const renderCard = useCallback(
    (card, index) => (
      <Card
        key={card._id}
        id={card._id}
        index={index}
        moveCard={moveCard}
        onClick={setSelectedCard}
        selected={selectedCard === index}
        setUploadDialogOpen={setUploadDialogOpen}
      >
        <Module item={card} selected={selectedCard === index} />
      </Card>
    ),
    [selectedCard, moveCard, setSelectedCard, setUploadDialogOpen]
  );

  return (
    <DndProvider backend={HTML5Backend}>
      <ul
        className={`max-h-full px-2 flex-col space-y-2 ${
          cards.length ? 'overflow-y-scroll' : 'scrollBar'
        }`}
      >
        {cards.map((card, i) => renderCard(card, i))}
        {cards.length ? null : (
          <button
            type="button"
            className="w-full h-8 bg-sky text-white rounded-md text-red shadow-md hover:shadow-lg"
            onClick={() => setUploadDialogOpen(true)}
          >
            <PlusIcon className="h-3 w-3 m-auto" />
          </button>
        )}
      </ul>
    </DndProvider>
  );
}

PreviewList.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  moveCard: PropTypes.func.isRequired,
  setSelectedCard: PropTypes.func.isRequired,
  selectedCard: PropTypes.number.isRequired,
  setUploadDialogOpen: PropTypes.func.isRequired,
};

export default PreviewList;
